import './SettingSection.pcss';
import React from 'react';
import classnames from 'classnames';
import { NeedHelpLabel } from '../../../common/components/NeedHelpLabel/NeedHelpLabel';

type Props = {
  title?: string;
  titleChildren?: string | JSX.Element | JSX.Element[];
  children: any;
  helpLink?: string;
  className?: string;
  childrenClassName?: string;
};

const SettingSection = (props: Props) => {
  const {
    children,
    helpLink,
    title,
    titleChildren,
    className,
    childrenClassName,
  } = props;
  const classList = classnames('setting-section', className);

  return (
    <div className={classList}>
      {title && (
        <div className="setting-section__title">
          {title}
          {helpLink && <NeedHelpLabel link={helpLink} />}
          {titleChildren}
        </div>
      )}

      <div className={classnames(childrenClassName)}>{children}</div>
    </div>
  );
};

export default SettingSection;
